const PUBLIC_VAPID_KEY = import.meta.env.VITE_PUBLIC_VAPID_KEY;
const apiServerUrl = import.meta.env.VITE_API_SERVER_URL;
import { AuthService } from '../services/auth-service';

async function subscribeToPush() {
    if (!("serviceWorker" in navigator)) {
        console.error("Service workers are not supported.");
        return;
    }
    if (!("PushManager" in window)) {
        console.error("Push notifications are not supported.");
        return;
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
        console.error("Permission not granted for notifications.");
        return;
    }

    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: PUBLIC_VAPID_KEY
    });

    const { endpoint, expirationTime, keys } = subscription.toJSON();

    // ✅ Get Auth Token
    const authToken = AuthService.getToken(); // Make sure this function exists

    if (!authToken) {
        console.error("User is not authenticated. Cannot subscribe.");
        return;
    }

    // Send the subscription data to the backend
    const response = await fetch(`${apiServerUrl}/subscribe`, {
        method: "POST",
        body: JSON.stringify({ endpoint, expirationTime, keys }),
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}` // ✅ Send the auth token
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        console.error("Subscription failed:", errorData);
        alert("Subscription failed. Please try again.");
        return;
    }

    console.log("User subscribed to push notifications!");
    alert("You have successfully subscribed to changes in your schedule");
}

export { subscribeToPush };
